import React from 'react'
import HotelSlugBanner from './HotelSlugBanner'

export default function HotelSlug() {
  return (
    <>
      <HotelSlugBanner/>
    </>
  )
}
